import {Currency} from './Currency';
import {useCryptoCurrenciesInfo} from './currencyInfoAtom';

export function useRateToPrimaryCurrency(currency: Currency) {
    const {data: currencyInfoList = []} = useCryptoCurrenciesInfo();
    const currencyInfo = currencyInfoList.find(i => i.code === currency.code);
    const rate: number = currencyInfo?.rateValue ?? 0;
    return rate;
}
